var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      _c("h1", [_vm._v("Mover por Remessa")]),
      _c("div", { staticClass: "containerTodo" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "label",
            [
              _vm._v("Caixa atual:"),
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "Digite a caixa atual", type: "text" },
                model: {
                  value: _vm.caixaAtual,
                  callback: function($$v) {
                    _vm.caixaAtual = $$v
                  },
                  expression: "caixaAtual"
                }
              })
            ],
            1
          ),
          _c(
            "label",
            [
              _vm._v("Caixa destino:"),
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "Digite a caixa destino", type: "text" },
                model: {
                  value: _vm.caixaDestino,
                  callback: function($$v) {
                    _vm.caixaDestino = $$v
                  },
                  expression: "caixaDestino"
                }
              })
            ],
            1
          ),
          _c(
            "label",
            { staticClass: "input" },
            [
              _vm._v("Saidas esperadas caixa destino:"),
              _c("el-input", {
                attrs: {
                  placeholder: "Saidas Esperadas Caixa Destino",
                  type: "number"
                },
                model: {
                  value: _vm.saidasEsperadasCaixaDestino,
                  callback: function($$v) {
                    _vm.saidasEsperadasCaixaDestino = $$v
                  },
                  expression: "saidasEsperadasCaixaDestino"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "containerDois" }, [
          _c(
            "label",
            { staticClass: "cont2" },
            [
              _vm._v("Ação inicial Caixa Destino:"),
              _c("el-input", {
                attrs: {
                  placeholder: "Digite ação inicial Caixa Destino",
                  type: "text"
                },
                model: {
                  value: _vm.acaoInicialCaixaDestino,
                  callback: function($$v) {
                    _vm.acaoInicialCaixaDestino = $$v
                  },
                  expression: "acaoInicialCaixaDestino"
                }
              })
            ],
            1
          ),
          _c(
            "label",
            { staticClass: "cont2" },
            [
              _vm._v("Status atuais:"),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: "Selecione os status atuais",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    "collapse-tags-tooltip": "collapse-tags-tooltip",
                    filterable: "filterable"
                  },
                  model: {
                    value: _vm.statusAtuais,
                    callback: function($$v) {
                      _vm.statusAtuais = $$v
                    },
                    expression: "statusAtuais"
                  }
                },
                _vm._l(_vm.status, function(s) {
                  return _c("el-option", {
                    key: s.codigo,
                    attrs: { label: s.nome, value: s.codigo }
                  })
                }),
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "container" }, [
          _c(
            "label",
            [
              _vm._v("Perfil:"),
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "Perfil", type: "text" },
                model: {
                  value: _vm.perfil,
                  callback: function($$v) {
                    _vm.perfil = $$v
                  },
                  expression: "perfil"
                }
              })
            ],
            1
          ),
          _c(
            "label",
            [
              _vm._v("Setor:"),
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "Setor" },
                model: {
                  value: _vm.setor,
                  callback: function($$v) {
                    _vm.setor = $$v
                  },
                  expression: "setor"
                }
              })
            ],
            1
          ),
          _c(
            "label",
            [
              _vm._v("Ação Destino:"),
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "Digite a ação Destino", type: "text" },
                model: {
                  value: _vm.acaoDestino,
                  callback: function($$v) {
                    _vm.acaoDestino = $$v
                  },
                  expression: "acaoDestino"
                }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "botaoContainer" },
          [_c("el-button", { on: { click: _vm.mover } }, [_vm._v("mover")])],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-035b7a85", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035b7a85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/MoverPorRemessa.vue
// module id = null
// module chunks = 